<script setup lang="ts">
const { setPageSeo } = useSeo()

await setPageSeo({
  title: 'École Jeu Vidéo & Médias Interactifs',
  description: 'Découvrez OXO, l\'école supérieure des métiers du jeu vidéo à Narbonne. Formations Game Art, Game Design, Programmation et plus encore.'
})

const { siteUrl, setStructuredData, fetchSchoolInfo } = useStructuredData()
const { data: schoolInfo } = await useAsyncData('school-info-structured-data', fetchSchoolInfo)
setStructuredData(buildOrganizationSchema(siteUrl, schoolInfo.value ?? {}))

</script>

<template>
  <div class="bg-background transition-colors duration-300">
    <HomeHero />
    <LazyHomeStats />
    <LazyHomeAgenda />
    <LazyHomeFormations />
    <LazyHomeProjects />
    <LazyHomeNews />
    <LazyHomePartners />
    <LazyHomeReviews />
    <LazyHomeTestimonials />
    <LazyHomeFAQ />
    <LazyHomeCTA />
  </div>
</template>
